import { createAsyncActionType } from './index';

export const LIVE_CLASSROOM_CONTENT_GET = createAsyncActionType('liveclassroom', 'LIVE_CLASSROOM_CONTENT_GET');

export const LIVE_CLASSROOM_COMMENTS_GET = createAsyncActionType('liveclassroom', 'LIVE_CLASSROOM_COMMENTS_GET');

export const LIVE_CLASSROOM_COMMENTS_SET = createAsyncActionType('liveclassroom', 'LIVE_CLASSROOM_COMMENTS_SET');

export const LIVE_CLASSROOM_LIKE_DISLIKE = createAsyncActionType('liveclassroom', 'LIVE_CLASSROOM_LIKE_DISLIKE');